export const PlusIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
    <rect x="11" y="4" width="2" height="16" rx="1" fill="#b0b0b0" />
    <rect x="4" y="11" width="16" height="2" rx="1" fill="#b0b0b0" />
  </svg>
);
